"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCollection = exports.ResourceCenterWithCollection = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cccisdApollo = require("cccisd-apollo");
var _helpers = require("./helpers");
var _CollectionSidebar = _interopRequireDefault(require("./CollectionSidebar"));
var _RecentPlansTable = _interopRequireDefault(require("./RecentPlansTable"));
var _ResourceCenter = _interopRequireDefault(require("../ResourceCenter"));
var _style = _interopRequireDefault(require("./style.css"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _uniq2 = _interopRequireDefault(require("lodash/uniq"));
var _mergeWith2 = _interopRequireDefault(require("lodash/mergeWith"));
var _progress = _interopRequireDefault(require("./progress.graphql"));
var _getPlan = _interopRequireDefault(require("./getPlan.graphql"));
var _getResources = _interopRequireDefault(require("./getResources.graphql"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } // import Loader from 'cccisd-loader';
var Fortress = window.cccisd.fortress;
var withCollection = exports.withCollection = function withCollection(Component, params) {
  return function (props) {
    var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      collection = _useState2[0],
      setCollection = _useState2[1];
    var _useState3 = (0, _react.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      collectionGroups = _useState4[0],
      setCollectionGroups = _useState4[1];
    var _useState5 = (0, _react.useState)([]),
      _useState6 = _slicedToArray(_useState5, 2),
      sessions = _useState6[0],
      setSessions = _useState6[1];
    var _useState7 = (0, _react.useState)({}),
      _useState8 = _slicedToArray(_useState7, 2),
      masterSessions = _useState8[0],
      setMasterSessions = _useState8[1];
    var _useState9 = (0, _react.useState)({
        planLabel: '',
        planDescription: '',
        Student: {
          timesToAssess: 1,
          schedule: 'semiweekly'
        },
        Caregiver: {
          timesToAssess: 1,
          schedule: 'semiweekly'
        },
        Educator: {
          timesToAssess: 1,
          schedule: 'semiweekly'
        },
        'Mental Health Provider': {
          timesToAssess: 1,
          schedule: 'semiweekly'
        }
      }),
      _useState0 = _slicedToArray(_useState9, 2),
      planSettings = _useState0[0],
      setPlanSettings = _useState0[1];
    var _useState1 = (0, _react.useState)([]),
      _useState10 = _slicedToArray(_useState1, 2),
      progressData = _useState10[0],
      setProgressData = _useState10[1];
    var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      progressLoaded = _useState12[0],
      setProgressLoaded = _useState12[1];
    var _useState13 = (0, _react.useState)(null),
      _useState14 = _slicedToArray(_useState13, 2),
      selectedPlan = _useState14[0],
      setSelectedPlan = _useState14[1];
    var _useState15 = (0, _react.useState)([]),
      _useState16 = _slicedToArray(_useState15, 2),
      planResources = _useState16[0],
      setPlanResources = _useState16[1];
    var _useState17 = (0, _react.useState)(false),
      _useState18 = _slicedToArray(_useState17, 2),
      isLoadingPlan = _useState18[0],
      setIsLoadingPlan = _useState18[1];
    (0, _react.useEffect)(function () {
      setCollection([]);
      setCollectionGroups({});
      setSessions([]);
      if (props.editCollection) {
        if (['copy', 'template'].includes(props.editCollection)) {
          setSessions(props.selectedPlan.sessionList.map(function (session) {
            return _objectSpread(_objectSpread({}, session), {}, {
              opensAt: '',
              closesAt: ''
            });
          }));
        } else {
          setSessions(props.selectedPlan.sessionList);
        }
        getProgress(props.selectedPlan.sessionList);
        loadPlanSettings();
      } else {
        setProgressLoaded(true);
      }
    }, []);
    (0, _react.useEffect)(function () {
      if (props.editCollection && progressLoaded) {
        loadCollection();
        addProgressToCollection(progressData);
      }
    }, [progressLoaded]);
    (0, _react.useEffect)(function () {
      // Handle RecentPlansTable setting the selected plan in react state
      if (planResources && planResources.length > 0) {
        setCollection([]);
        setCollectionGroups({});
        setSessions(selectedPlan.sessionList);
        var settings = JSON.parse(selectedPlan.settings);
        if (settings && settings.planSettings) {
          setPlanSettings(settings.planSettings);
        }
        planResources.forEach(function (r) {
          addToCollection(r);
        });
      }
    }, [selectedPlan, planResources]);
    var addToCollection = function addToCollection(item) {
      setCollection(function (current) {
        return [].concat(_toConsumableArray(current), [item]);
      });
      if (progressLoaded) {
        addProgressToCollection(progressData);
      }
      setCollectionGroups(function (current) {
        var stateCopy = _objectSpread({}, current);
        Object.values(item.tags).forEach(function (tag) {
          if (tag in stateCopy) {
            stateCopy[tag].push(item);
          } else {
            stateCopy[tag] = [item];
          }
        });
        return stateCopy;
      });
      var itemTags = Object.values(item.tags);
      if (sessions.length > 0) {
        sessions.forEach(function (session) {
          if (itemTags.includes(session.settings.reporter)) {
            if (!(0, _find2["default"])(session.settings.sessionCollection, {
              id: item.id
            })) {
              setSessions(function (prev) {
                var sessionsCopy = (0, _cloneDeep2["default"])(prev);
                var currentSession = sessionsCopy.find(function (s) {
                  return s.settings.sessionId === session.settings.sessionId;
                });
                currentSession.settings.sessionCollection.push(item);
                currentSession.settings.options = (0, _helpers.getSurveyHandles)(currentSession.settings.sessionCollection, currentSession.settings.disabledSurveys);
                currentSession.settings.resourceIds = currentSession.settings.sessionCollection.map(function (r) {
                  return r.id;
                });
                return sessionsCopy;
              });
            }
          }
        });
        Object.keys(masterSessions).forEach(function (reporter) {
          if (itemTags.includes(reporter)) {
            if (masterSessions[reporter] && !(0, _find2["default"])(masterSessions[reporter].settings.sessionCollection, {
              id: item.id
            })) {
              setMasterSessions(function (prev) {
                var masterCopy = (0, _cloneDeep2["default"])(prev);
                var masterSession = masterCopy[reporter];
                masterSession.settings.sessionCollection.push(item);
                masterSession.settings.options = (0, _helpers.getSurveyHandles)(masterSession.settings.sessionCollection, masterSession.settings.disabledSurveys);
                masterSession.settings.resourceIds = masterSession.settings.sessionCollection.map(function (r) {
                  return r.id;
                });
                return masterCopy;
              });
            }
          }
        });
      }
    };
    var removeFromCollection = function removeFromCollection(id) {
      setCollection(collection.filter(function (i) {
        return i.id !== id;
      }));
      var cgCopy = _objectSpread({}, collectionGroups);
      if (cgCopy && Object.keys(cgCopy).length > 0) {
        Object.keys(cgCopy).forEach(function (key) {
          var ids = cgCopy[key].map(function (resource) {
            return resource.id;
          });
          if (ids.includes(id)) {
            cgCopy[key] = cgCopy[key].filter(function (item) {
              return item.id !== id;
            });
          }
        });
        setCollectionGroups(cgCopy);
      }
      if (sessions.length > 0) {
        sessions.forEach(function (session) {
          if ((0, _find2["default"])(session.settings.sessionCollection, {
            id: id
          })) {
            if (session.settings.sessionCollection.length === 1) {
              // If this is the last item in the session, remove the session
              setSessions(function (prev) {
                return prev.filter(function (s) {
                  return s.settings.sessionId !== session.settings.sessionId;
                });
              });
            } else {
              // Otherwise, just remove the item from the session
              // and update the session options and resourceIds
              setSessions(function (prev) {
                var sessionsCopy = (0, _cloneDeep2["default"])(prev);
                var currentSession = sessionsCopy.find(function (s) {
                  return s.settings.sessionId === session.settings.sessionId;
                });
                currentSession.settings.sessionCollection = currentSession.settings.sessionCollection.filter(function (x) {
                  return id !== x.id;
                });
                currentSession.settings.resourceIds = currentSession.settings.resourceIds.filter(function (x) {
                  return id !== x;
                });
                currentSession.settings.disabledSurveys = currentSession.settings.disabledSurveys.filter(function (x) {
                  return id !== x;
                });
                currentSession.settings.options = (0, _helpers.getSurveyHandles)(currentSession.settings.sessionCollection, currentSession.settings.disabledSurveys);
                currentSession.settings.resourceIds = currentSession.settings.sessionCollection.map(function (r) {
                  return r.id;
                });
                return sessionsCopy;
              });
            }
          }
        });
        Object.keys(masterSessions).forEach(function (reporter) {
          if (masterSessions[reporter] && (0, _find2["default"])(masterSessions[reporter].settings.sessionCollection, {
            id: id
          })) {
            setMasterSessions(function (prev) {
              var masterCopy = (0, _cloneDeep2["default"])(prev);
              var masterSession = masterCopy[reporter];
              masterSession.settings.sessionCollection = masterSession.settings.sessionCollection.filter(function (item) {
                return item.id !== id;
              });
              return masterCopy;
            });
          }
        });
      }
    };
    var getProgress = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(sessionData) {
        var contacts,
          data,
          combinedSessionsData,
          metrics,
          pawnIds,
          _props$progressQuery,
          resp,
          _args = arguments;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              contacts = _args.length > 1 && _args[1] !== undefined ? _args[1] : [{
                pawn: {
                  pawnId: Fortress.user.acting.id
                }
              }];
              setProgressLoaded(false);
              data = []; // Collect unique deploymentIds and surveyHandles from every session in current plan
              combinedSessionsData = {
                deployments: new Set(),
                surveyList: new Set()
              };
              sessionData.forEach(function (session) {
                if (session.sessionDeploymentInfo) {
                  Object.values(session.sessionDeploymentInfo).forEach(function (s) {
                    return combinedSessionsData.deployments.add(s.deploymentId);
                  });
                }
                combinedSessionsData.deployments.add(session.deploymentId);
                session.settings.options.forEach(function (surveyHandle) {
                  return combinedSessionsData.surveyList.add(surveyHandle);
                });
              });
              metrics = _toConsumableArray(combinedSessionsData.surveyList).map(function (surveyHandle) {
                return [surveyHandle + '_start', surveyHandle + '_lastVisited', surveyHandle + '_end'];
              }).flat();
              pawnIds = contacts.map(function (contact) {
                return contact.pawn.pawnId;
              });
              if (props.collectionUserList && props.collectionUserList.length > 0) {
                props.collectionUserList.forEach(function (u) {
                  return pawnIds.push(u.id);
                });
              }
              _context.prev = 8;
              _context.next = 11;
              return _cccisdApollo.client.query({
                query: (_props$progressQuery = props.progressQuery) !== null && _props$progressQuery !== void 0 ? _props$progressQuery : _progress["default"],
                variables: {
                  deploymentIds: _toConsumableArray(combinedSessionsData.deployments),
                  metrics: metrics,
                  surveyHandles: _toConsumableArray(combinedSessionsData.surveyList),
                  pawnIds: pawnIds
                },
                fetchPolicy: 'network-only'
              });
            case 11:
              resp = _context.sent;
              setProgressData(resp.data.flows.assignmentProgressList);
              data = resp.data.flows.assignmentProgressList;
              _context.next = 19;
              break;
            case 16:
              _context.prev = 16;
              _context.t0 = _context["catch"](8);
              throw _context.t0;
            case 19:
              setProgressLoaded(true);
              return _context.abrupt("return", data);
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[8, 16]]);
      }));
      return function getProgress(_x) {
        return _ref.apply(this, arguments);
      };
    }();
    var addProgressToCollection = function addProgressToCollection() {
      var surveyProgress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var surveyProgressFlat = {};
      surveyProgress.forEach(function (sp) {
        // Object.assign will merge two objects, but does not favor non-null values,
        // we need to use lodash's mergeWith to favor non-null values when merge collisions are possible
        Object.assign(surveyProgressFlat, sp.variables);
        // In case we pass in props.progressQuery (because we are using app devTags),
        //  we need to merge progress from devTags as well
        if (sp.devTags) {
          surveyProgressFlat = (0, _mergeWith2["default"])(surveyProgressFlat, sp.devTags, function (a, b) {
            return b === null ? a : undefined;
          });
        }
      });
      setCollection(function (prev) {
        var collectionCopy = (0, _cloneDeep2["default"])(prev);
        collectionCopy.forEach(function (cItem) {
          var surveyHandle = JSON.parse(cItem.resource.published_metadata).surveyInfo.surveyHandle;
          var current = collectionCopy.find(function (c) {
            return c.id === cItem.id;
          });
          current.surveyHandle = surveyHandle;
          current.progress = {};
          ['start', 'lastVisited', 'end'].forEach(function (suffix) {
            if (surveyProgressFlat[surveyHandle + '_' + suffix]) {
              current.progress[suffix] = surveyProgressFlat[surveyHandle + '_' + suffix];
            }
          });
        });
        return collectionCopy;
      });
    };
    var getFlowLanguages = function getFlowLanguages(metadata) {
      var languages = new Set();
      if (metadata.surveyInfo && metadata.surveyInfo.flowList) {
        metadata.surveyInfo.flowList.forEach(function (flow) {
          languages.add(flow.language);
        });
      }
      return _toConsumableArray(languages);
    };
    var getPlan = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(planId) {
        var resp, assignmentPlan;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return _cccisdApollo.client.query({
                query: _getPlan["default"],
                variables: {
                  planId: planId
                },
                fetchPolicy: 'network-only'
              });
            case 3:
              resp = _context2.sent;
              assignmentPlan = resp.data.flows.assignmentPlan;
              setSelectedPlan(assignmentPlan);
              return _context2.abrupt("return", assignmentPlan);
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](0);
              throw _context2.t0;
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 9]]);
      }));
      return function getPlan(_x2) {
        return _ref2.apply(this, arguments);
      };
    }();
    var getPlanResources = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(planId) {
        var plan, resourceIds, resourcesResp, formattedResources;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getPlan(planId);
            case 2:
              plan = _context3.sent;
              resourceIds = (0, _uniq2["default"])(plan.sessionList.map(function (session) {
                return session.settings.resourceIds;
              }).flat());
              _context3.prev = 4;
              if (!(resourceIds && resourceIds.length > 0)) {
                _context3.next = 12;
                break;
              }
              _context3.next = 8;
              return _cccisdApollo.client.query({
                query: _getResources["default"],
                variables: {
                  resourceIds: resourceIds
                },
                fetchPolicy: 'network-only'
              });
            case 8:
              resourcesResp = _context3.sent;
              formattedResources = formatResourcesForCollection(resourcesResp.data.resources.resourceList);
              setPlanResources(formattedResources);
              return _context3.abrupt("return", formattedResources);
            case 12:
              _context3.next = 17;
              break;
            case 14:
              _context3.prev = 14;
              _context3.t0 = _context3["catch"](4);
              throw _context3.t0;
            case 17:
              return _context3.abrupt("return", []);
            case 18:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[4, 14]]);
      }));
      return function getPlanResources(_x3) {
        return _ref3.apply(this, arguments);
      };
    }();
    var formatResourcesForCollection = function formatResourcesForCollection(resourceList) {
      var formattedResources = resourceList.map(function (r) {
        var tags = r.tagList.reduce(function (acc, cur) {
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, cur.tagId, cur.handle));
        }, {});
        return {
          id: r.resourceId,
          label: r.label,
          description: r.description,
          tags: tags,
          languages: getFlowLanguages(JSON.parse(r.metadata)),
          resource: {
            published_metadata: r.metadata
          }
        };
      });
      return formattedResources;
    };
    var handlePlanSelection = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(planId) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (planId) {
                _context4.next = 7;
                break;
              }
              setSelectedPlan(null);
              setPlanResources([]);
              setCollection([]);
              setCollectionGroups({});
              setSessions([]);
              return _context4.abrupt("return");
            case 7:
              setIsLoadingPlan(true);
              _context4.prev = 8;
              _context4.next = 11;
              return getPlanResources(planId);
            case 11:
              _context4.next = 16;
              break;
            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4["catch"](8);
              console.error('Error loading plan:', _context4.t0);
            case 16:
              _context4.prev = 16;
              setIsLoadingPlan(false);
              return _context4.finish(16);
            case 19:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[8, 13, 16, 19]]);
      }));
      return function handlePlanSelection(_x4) {
        return _ref4.apply(this, arguments);
      };
    }();
    var loadCollection = function loadCollection() {
      if (props.planResources) {
        props.planResources.forEach(function (r) {
          addToCollection(r);
        });
      } else if (planResources.length > 0) {
        planResources.forEach(function (r) {
          addToCollection(r);
        });
      }
    };
    var loadPlanSettings = function loadPlanSettings() {
      var plan = props.selectedPlan || selectedPlan;
      if (plan && plan.settings) {
        var settings = JSON.parse(plan.settings);
        if (settings && settings.planSettings) {
          setPlanSettings(settings.planSettings);
        }
      }
    };

    // if (!progressLoaded || isLoadingPlan) {
    //     return <Loader loading />;
    // }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].collectionWrapper
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].componentWrapper
    }, !props.editCollection && /*#__PURE__*/_react["default"].createElement(_RecentPlansTable["default"], {
      onPlanSelect: handlePlanSelection,
      loading: isLoadingPlan
    }), /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, {
      collection: collection,
      addToCollection: addToCollection,
      removeFromCollection: removeFromCollection,
      addToCollectionButtonLabel: props.addToCollectionButtonLabel,
      preventLayoutChange: props.preventLayoutChange
    }))), /*#__PURE__*/_react["default"].createElement(_CollectionSidebar["default"], {
      collection: collection,
      removeFromCollection: removeFromCollection,
      collectionGroups: collectionGroups,
      sessions: sessions,
      setSessions: setSessions,
      planSettings: planSettings,
      setPlanSettings: setPlanSettings,
      collectionUserList: props.collectionUserList,
      onSubmit: props.onSubmit,
      editCollection: props.editCollection,
      selectedPlan: props.selectedPlan,
      onDelete: props.onDelete,
      collectionBuckets: props.collectionBuckets,
      collectionName: props.collectionName,
      logo: props.logo,
      planName: props.planName,
      collectionBucketsFormTitle: props.collectionBucketsFormTitle,
      disableTimepoints: props.disableTimepoints,
      styleConfig: props.styleConfig,
      assessmentLibraryLabel: props.assessmentLibraryLabel,
      baselineSessionLabel: props.baselineSessionLabel,
      assessmentLabel: props.assessmentLabel,
      surveyLabel: props.surveyLabel,
      masterSessions: masterSessions,
      setMasterSessions: setMasterSessions,
      isLoadingPlan: isLoadingPlan
    }));
  };
};
var ResourceCenterWithCollection = exports.ResourceCenterWithCollection = withCollection(_ResourceCenter["default"]);
ResourceCenterWithCollection.propTypes = {
  collection: _propTypes["default"].array,
  addToCollection: _propTypes["default"].func,
  removeFromCollection: _propTypes["default"].func,
  addToCollectionButtonLabel: _propTypes["default"].string,
  collectionGroups: _propTypes["default"].object,
  sessions: _propTypes["default"].array,
  setSessions: _propTypes["default"].func,
  collectionUserList: _propTypes["default"].array,
  onSubmit: _propTypes["default"].func,
  editCollection: _propTypes["default"].string,
  selectedPlan: _propTypes["default"].object,
  collectionBuckets: _propTypes["default"].array,
  collectionName: _propTypes["default"].string,
  logo: _propTypes["default"].node,
  planName: _propTypes["default"].string,
  collectionBucketsFormTitle: _propTypes["default"].string,
  disableTimepoints: _propTypes["default"].bool,
  styleConfig: _propTypes["default"].object,
  assessmentLibraryLabel: _propTypes["default"].string,
  baselineSessionLabel: _propTypes["default"].string,
  assessmentLabel: _propTypes["default"].string,
  surveyLabel: _propTypes["default"].string,
  progressQuery: _propTypes["default"].object,
  planResources: _propTypes["default"].array,
  preventLayoutChange: _propTypes["default"].bool
};
ResourceCenterWithCollection.defaultProps = {
  collection: [],
  addToCollection: function addToCollection() {},
  removeFromCollection: function removeFromCollection() {},
  addToCollectionButtonLabel: 'Add to Collection',
  collectionGroups: {},
  sessions: [],
  setSessions: function setSessions() {},
  collectionUserList: [],
  onSubmit: function onSubmit() {},
  editCollection: '',
  selectedPlan: {},
  collectionBuckets: [],
  collectionName: '',
  logo: null,
  planName: '',
  collectionBucketsFormTitle: '',
  disableTimepoints: false,
  styleConfig: {},
  assessmentLibraryLabel: 'Assessment Library',
  baselineSessionLabel: 'Baseline',
  assessmentLabel: 'Assessment',
  surveyLabel: 'Survey',
  progressQuery: null,
  planResources: [],
  preventLayoutChange: true
};